<template>
<div>
  <Header />
  <LoadingDialog ref="LoadingDialog" />
  <v-container grid-list-md fluid class="container-style">

    <div class="container-header">
      <span>Statistics</span>
    </div>
    <v-layout row wrap justify-end>

    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-card min-height="350px">
          <v-layout justify-center class="stat-margin">
            <v-flex xs12 class="px-2 py-2">

              <v-list class="stat-list" v-if="statistics.total_students">
                <v-list-group :value="true">
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Overall</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <v-list-tile class="pl-2">
                    <v-list-tile-content>
                      <v-list-tile-title>Total Students: {{ statistics.total_students.total }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile class="pl-2">
                    <v-list-tile-content>
                      <v-list-tile-title>Total Male Students: {{ statistics.total_students.male }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile class="pl-2">
                    <v-list-tile-content>
                      <v-list-tile-title>Total Female Students: {{ statistics.total_students.female }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list class="stat-list">
                    <v-list-group :value="true">
                      <template v-slot:activator>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>Pre-School</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Students: {{ statistics.total_students.departments.pre_school.total }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.pre_school.male }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.pre_school.female }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Nursery</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.pre_school.grade_levels.nursery.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.pre_school.grade_levels.nursery.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.pre_school.grade_levels.nursery.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Kinder 1</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.pre_school.grade_levels.kinder_one.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.pre_school.grade_levels.kinder_one.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.pre_school.grade_levels.kinder_one.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Kinder 2</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.pre_school.grade_levels.kinder_two.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.pre_school.grade_levels.kinder_two.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.pre_school.grade_levels.kinder_two.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                    </v-list-group>
                  </v-list>

                  <v-list class="stat-list">
                    <v-list-group :value="true">
                      <template v-slot:activator>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>Grade School</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Students: {{ statistics.total_students.departments.grade_school.total }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.grade_school.male }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.grade_school.female }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 1</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_1.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_1.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_1.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 2</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_2.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_2.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_2.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 3</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_3.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_3.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_3.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 4</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_4.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_4.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_4.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 5</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_5.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_5.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_5.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 6</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_6.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_6.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.grade_school.grade_levels.grade_6.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                    </v-list-group>
                  </v-list>

                  <v-list class="stat-list">
                    <v-list-group :value="true">
                      <template v-slot:activator>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>Jr. High School</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Students: {{ statistics.total_students.departments.jr_high_school.total }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.jr_high_school.male }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.jr_high_school.female }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 7</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_7.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_7.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_7.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 8</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_8.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_8.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_8.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 9</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_9.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_9.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_9.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 10</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_10.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_10.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.jr_high_school.grade_levels.grade_10.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                    </v-list-group>
                  </v-list>

                  <v-list class="stat-list">
                    <v-list-group :value="true">
                      <template v-slot:activator>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>Sr. High School</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Students: {{ statistics.total_students.departments.sr_high_school.total }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.sr_high_school.male }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile class="pl-2">
                        <v-list-tile-content>
                          <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.sr_high_school.female }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 11</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.sr_high_school.grade_levels.grade_11.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.sr_high_school.grade_levels.grade_11.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.sr_high_school.grade_levels.grade_11.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                      <v-list class="stat-list">
                        <v-list-group class="pl-4">
                          <template v-slot:activator>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Grade 12</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Students: {{ statistics.total_students.departments.sr_high_school.grade_levels.grade_12.total }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Male Students: {{ statistics.total_students.departments.sr_high_school.grade_levels.grade_12.male }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-list-tile class="pl-2">
                            <v-list-tile-content>
                              <v-list-tile-title>Total Female Students: {{ statistics.total_students.departments.sr_high_school.grade_levels.grade_12.female }}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list-group>
                      </v-list>

                    </v-list-group>
                  </v-list>

                </v-list-group>
              </v-list>

            </v-flex>
          </v-layout>
          <v-navigation-drawer v-model="drawer" permanent absolute>
            <v-toolbar flat class="transparent">
              <v-list class="pa-1">
                <v-list-tile avatar>
                  <v-list-tile-content>
                    <v-layout>
                      <v-flex xs12>
                        <v-autocomplete v-model="selectedSchoolYear" :items="schoolYears" item-text="name" item-value="id" return-object color="#091D3B" label="School Year" class="title font-weight-black disabled-field">
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-toolbar>

            <v-list class="pt-0 stat-item">
              <v-divider></v-divider>

              <v-list-tile v-for="item in items" :key="item.title" @click="">
                <v-list-tile-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile class="mt-5 mobile-only">
                <v-list-tile-action>
                  <v-icon color="blue darken-1">mdi-gesture-swipe-left</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title class="blue--text">(Swipe left to uncover)</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

            </v-list>
          </v-navigation-drawer>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import Header from '@/components/Header.vue'

import {
  mapState,
  mapActions
} from "vuex";

import LoadingDialog from '@/components/LoadingDialog.vue'

export default {
  components: {
    Header,
    LoadingDialog,
  },
  computed: {
    ...mapState(['schoolYears', 'statistics']),
  },
  data() {
    return {
      selectedSchoolYear: null,
      drawer: true,
      items: [{
          title: 'Overall',
          icon: 'dashboard'
        },
        // {
        //   title: 'Department',
        //   icon: 'mdi-book-open-page-variant'
        // },
        // {
        //   title: 'Grade Level',
        //   icon: 'mdi-school'
        // }
      ],
      right: null,
    }
  },
  methods: {
    ...mapActions(['getSchoolYears', 'getOverallStatistics']),
  },
  created() {
    this.getSchoolYears()
      .then((data) => {
        this.selectedSchoolYear = this.schoolYears[0]
        this.getOverallStatistics(this.selectedSchoolYear)
          .then((data) => {

          })
          .catch((data) => {

          })
      })
      .catch((data) => {

      })
  },
}
</script>
